module.exports = __webpack_public_path__ + "img/am3-optin-promo.5c7a07f.png";